import { inject, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AbstractTransport } from 'models/abstract-transport.model';

@Pipe({
  name: 'transportPeriod',
  standalone: true,
})
export class TransportPeriodPipe implements PipeTransform {
  readonly #datePipe = inject(DatePipe);

  transform(value: AbstractTransport, options: { pickup?: boolean; delivery?: boolean }): string {
    if (!options.pickup && !options.delivery) {
      return '';
    }
    let result = '';
    if (options.pickup) {
      if (value.pickupMeeting) {
        result = 'Sur rendez-vous';
      } else {
        result += 'Le ' + this.#datePipe.transform(value.pickupDate?.toDate(), 'shortDate');
        if (value.pickupTimeslotStart && value.pickupTimeslotEnd) {
          result += ' entre ' + value.pickupTimeslotStart + 'h et ' + value.pickupTimeslotEnd + 'h';
        }
      }
      if (value.pickupPhoneCall !== null && value.pickupPhoneCall !== undefined && value.pickupPhoneCall) {
        result += ' (appeler une heure avant)';
      }
    }
    if (options.delivery) {
      if (value.deliveryMeeting) {
        result = 'Sur rendez-vous';
      } else {
        const dateDelivery: string = this.#datePipe.transform(value.deliveryDate?.toDate(), 'shortDate')!;
        if (value.deliveryMaxDate) {
          result = `Entre le ${dateDelivery} et le ${this.#datePipe.transform(value.deliveryMaxDate?.toDate(), 'shortDate')} ${
            value.deliveryTimeslotStart ? 'de ' + value.deliveryTimeslotStart + 'h et ' : ''
          }${value.deliveryTimeslotEnd ? value.deliveryTimeslotEnd + 'h' : ''}`;
        } else {
          result = `Le ${dateDelivery} ${value.deliveryTimeslotStart ? 'entre ' + value.deliveryTimeslotStart + 'h et' : ''}${
            value.deliveryTimeslotEnd ? value.deliveryTimeslotEnd + 'h' : ''
          }`;
        }
      }
      if (value.deliveryPhoneCall) {
        result += ' (appeler une heure avant)';
      }
    }
    return `${result}.`;
  }
}
